import { Spinner } from './Spinner';
import { Button } from './Button';
import { Card } from './Card';

interface Props {
  hostName: string;
  onCancel: () => void;
}

export function ApprovalWaiting({ hostName, onCancel }: Props) {
  return (
    <main className="grid h-screen place-items-center px-4">
      <Card variant="elevated" className="w-full max-w-md p-8 text-center">
        <Spinner className="mx-auto h-8 w-8 text-text-secondary" />
        <div className="mt-6 space-y-1">
          <h1 className="text-lg font-semibold text-text-primary">Waiting for host to approve</h1>
          <p className="text-sm text-text-secondary">
            <span
              aria-hidden
              className="mr-2 inline-block h-1.5 w-1.5 rounded-full bg-accent shadow-[0_0_10px_var(--color-accent)] animate-[pulse-dot_1.6s_ease-in-out_infinite] align-middle"
            />
            <span className="font-mono align-middle">{hostName}</span>
            <span className="align-middle"> needs to accept the connection.</span>
          </p>
        </div>
        <Button variant="secondary" onClick={onCancel} className="mt-6 w-full">Cancel</Button>
      </Card>
    </main>
  );
}
